import { render, staticRenderFns } from "./medicinePolicyAdd.vue?vue&type=template&id=91c08148&scoped=true"
import script from "./medicinePolicyAdd.vue?vue&type=script&lang=js"
export * from "./medicinePolicyAdd.vue?vue&type=script&lang=js"
import style0 from "./medicinePolicyAdd.vue?vue&type=style&index=0&id=91c08148&prod&lang=less&scoped=true"
import style1 from "./medicinePolicyAdd.vue?vue&type=style&index=1&id=91c08148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c08148",
  null
  
)

export default component.exports